
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/customization/palette",
      function () {
        return require("private-next-pages/material-ui/customization/palette.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/customization/palette"])
      });
    }
  